import type * as React from 'react';
import { del } from '@Domain/Api';
import documentTypeRestored, {
	type DocumentTypeRestoredAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeRestored';
import documentTypeRestoringFailed, {
	type DocumentTypeRestoringFailedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeRestoringFailed';
import type RestoreDocumentType from '@Application/Documents/DocumentTypes/Commands/RestoreDocumentType';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTypeRestoredAction | DocumentTypeRestoringFailedAction;

export default (command: RestoreDocumentType) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// `204`, no body.
			await del<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/document-types/${command.documentTypeId}/archivals`,
			);

			const action = documentTypeRestored(
				{ documentTypeId: command.documentTypeId },
				command.accountId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTypeRestoringFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
